<template>
    <!-- 参数配置相关组件，被资源组详情，主机（实例）详情，以及主机模板详情三个页面所引用，quote作为区分参数，谨慎修改 -->
    <div class="module paramConfig">
        <div class="module-container">
            <Row class="content"
                 v-show="titles.length>0">
                <i-col style="padding-right: 15px;"
                       span="24">
                    <Collapse v-model="collapseShow">
                        <Panel v-for="(item,index) in titles"
                               :key="item"
                               :name="item">
                            {{item}}
                            <span class="count">{{attrs[index].source.tableData.totalRows}}</span>
                            <p slot="content">
                                <rcTable ref="rcTable"
                                         class="rcTable"
                                         :tableAttr="attrs[index]" />
                            </p>
                        </Panel>
                    </Collapse>
                </i-col>
            </Row>
            <div v-show="titles.length<1">
                <div class="no-item">
                    <span class="no-img"></span>
                    {{$t('没有参数显示')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import rcTable from '@c/basic/rcTable'
import API from '@/service/api'
export default {
    name: 'paramConfig',
    props: ['isLocak', 'quote', 'isNoPer'],
    components: {
        rcTable
    },
    data () {
        return {
            isEdit: false,
            collapseShow: '',
            tableDetail: {
                hideHead: true,
                hideFooter: true,
                source: {
                    type: 'staticData',
                    tableData: {
                        totalRows: 0,
                        dataList: []
                    }
                },
                columns: [
                    {
                        key: 'name',
                        title: this.$i18n.t('参数'),
                        render: (h, params) => {
                            return h('span', params.row.name)
                        }
                    }, {
                        key: 'defaultValue',
                        title: this.$i18n.t('值'),
                        render: (h, params) => {
                            if (this.isEdit) {
                                return h('div', [
                                    h('Select', {
                                        style: 'width: 100px;',
                                        props: {
                                            value: params.row.defaultValueType,
                                            transfer: true
                                        },
                                        on: { 'on-change': (value) => this.RecordCodeFun(params.row, 'type', value) }
                                    }, [h('Option', { props: { value: 'text' } }, this.$i18n.t('文本'))]),
                                    h('Input', {
                                        style: 'width: 200px;',
                                        props: { value: params.row.defaultValue },
                                        on: { 'on-change': (e) => this.RecordCodeFun(params.row, 'value', e.target.value) }
                                    })
                                ])
                            } else {
                                return h('span', params.row.defaultValue)
                            }
                        }
                    }, {
                        key: 'isRequired',
                        title: this.$i18n.t('是否必填'),
                        width: 100,
                        render: (h, params) => {
                            return h('span', params.row.isRequired === 1 || params.row.isRequired === 1 ? this.$i18n.t('是') : this.$i18n.t('否'))
                        }
                    }
                ]
            },
            codeData: [],
            attrs: [],
            titles: []
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {
            this.titles = []
            let apiUrl = ''
            switch (this.quote) {
                case 'source':
                    apiUrl = API.GET_RES_PARAMS_SETTING
                    break
                case 'host':
                    apiUrl = API.GET_HOST_PARAMCONFIG
                    break
                case 'template':
                    apiUrl = API.GET_TEMPLATE_PARAMS
                    break
            }
            this.axios.get(this.urlFormat(apiUrl, true, [this.$route.params.id])).then(newres => {
                const arr = []
                newres && newres.length && newres.forEach((item, i) => {
                    arr.push(item.category)
                    this.attrs.push(this.tableDetail)
                    this.attrs[i].source.tableData.dataList = item.data || []
                    this.attrs[i].source.tableData.totalRows = item.data.length || 0
                })
                this.titles = arr
                this.$nextTick(() => {
                    this.collapseShow = this.titles[0]
                })
            })
        },
        // 记录所有修改的参数和id（方便提交请求）
        RecordCodeFun (row, type, value) {
            const isReplay = this.codeData.some((item) => item.id === row.id)
            if (!isReplay) {
                this.codeData.push({
                    id: row.id,
                    defaultValueType: row.defaultValueType,
                    defaultValue: row.defaultValue,
                    isRequired: row.isRequired
                })
            }
            const indexNo = this.codeData.findIndex((item) => item.id === row.id)
            const typeValue = type === 'value' ? 'defaultValue' : 'defaultValueType'
            this.codeData[indexNo][typeValue] = value
        },
        // 调整参数
        changeIsEditStatus () {
            if (this.quote === 'template' && (!this.hasPermission('MC0110'))) return
            this.isEdit = true
        },
        save () {
            // 判断是否有必填参数未填，判断完就删掉
            for (const item of this.codeData) {
                if ((item.isRequired === 1 || item.isRequired === 1) && (!item.defaultValue)) {
                    this.$Message.error(this.$i18n.t('您有必填的参数未填，请补充完整'))
                    return
                } else {
                    delete item.isRequired
                }
            }
            let apiUrl = ''
            switch (this.quote) {
                case 'source':
                    apiUrl = API.PUT_RES_DEPLOY_PARAMS
                    break
                case 'host':
                    apiUrl = API.PUT_RES_HOSTS_PARAMS
                    break
                case 'template':
                    apiUrl = API.PUT_RES_TEMPLATE_PARAMS
                    break
            }
            this.axios.put(apiUrl, this.codeData).then(res => {
                this.cancel()
                this.init()
            })
        },
        cancel () {
            this.isEdit = false
        }
    }
}
</script>

<style lang="less">
.paramConfig {
    .ivu-collapse-header {
        background-color: white;
        color: #333;
        .count {
            width: 16px;
            height: 16px;
            display: inline-block;
            background-color: #3498dc;
            color: white;
            border-radius: 50%;
            text-align: center;
            line-height: 16px;
            margin-left: 5px;
        }
    }
    .tooltip {
        margin-bottom: 15px;
        position: relative;
        .params-info {
            height: 100%;
            position: absolute;
            top: 0px;
            right: 15px;
            display: flex;
            align-items: center;
            font-size: 16px;
            p {
                font-size: 14px;
                color: #333;
                margin-left: 5px;
                font-weight: 400;
            }
            span {
                margin: 0px 5px;
                font-size: 12px;
                color: #666;
                .tip-div {
                    width: 15px;
                    height: 15px;
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 5px;
                }
                .info {
                    display: inline-block;
                    vertical-align: middle;
                }
            }
        }
    }
    .rc-bac-yellow {
        background-color: #ffc000;
    }
    .rc-bac-red {
        background-color: #ef4235;
    }
    .no-item {
        font-size: 16px;
        padding-top: 100px;
        padding-left: 40%;
        line-height: 250px;
        color: #333;
        .no-img {
            display: inline-block;
            width: 156px;
            height: 101px;
            position: relative;
            top: 43px;
            left: -10px;
            // background-image: url(../../../../assets/images/no-params.png);
        }
    }
}
</style>
